import script from "./BaseRadioBullet.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadioBullet.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadioBullet.vue?vue&type=style&index=0&id=5215688e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5215688e"]])

export default __exports__